import axios from "axios";
import { Button } from "antd";
import DashboardContext from "Context";
import { useContext, useState } from "react";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function Excel({
  data = [],
  headers = [],
  fileName = "",
  server = false,
  fromHcm = false,
  methodIsGet = false,
  isDisabled = false,
  props = {},
  url = "",
}) {
  const [loading, setLoading] = useState(false);
  const { urldashboard, authentication, handelerrors, urlHcm } =
    useContext(DashboardContext);

  const getExcelReport = async () => {
    setLoading(true);

    try {
      const res = methodIsGet
        ? await axios.get(`${!fromHcm ? urldashboard : urlHcm}${url}`, {
            headers: {
              Authorization: authentication,
              "Content-Type": "application/json",
            },
            params: {
              ...props,
            },
            responseType: "arraybuffer",
          })
        : await axios.post(`${urldashboard}${url}`, JSON.stringify(props), {
            headers: {
              Authorization: authentication,
              "Content-Type": "application/json",
            },
            responseType: "arraybuffer",
          });

      let blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName}.xlsx`;
      link.click();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handelerrors(error);
    }
  };

  return (
    <>
      {server ? (
        <Button
          type='primary'
          className='btn btn-excel border border-secondary rounded-0'
          style={{ height: "3rem" }}
          onClick={() => getExcelReport()}
          loading={loading}
          disabled={isDisabled}
        >
          خروجی اکسل
          <i className='mdi mdi-file-excel-box mr-2'></i>
        </Button>
      ) : (
        <ExcelFile
          filename={fileName}
          element={
            <Button style={{ height: "3rem" }} disabled={isDisabled}>
              خروجی اکسل
              <i className='mdi mdi-file-excel-box mr-2'></i>
            </Button>
          }
        >
          <ExcelSheet data={data} name={fileName}>
            {data.length > 0 &&
              headers.map((_, index) => {
                return (
                  <ExcelColumn
                    key={index.toString()}
                    label={headers[index]}
                    value={
                      Object.keys(data[0])[index] === "workerOrderSchedules"
                        ? ""
                        : Object.keys(data[0])[index]
                    }
                  />
                );
              })}
          </ExcelSheet>
        </ExcelFile>
      )}
    </>
  );
}
